export default __webpack_public_path__ + "static/media/thumb_12.9ea7922e.webp";